module.exports = __webpack_public_path__ + "img/foreground-circuit-03.4b699bfe.svg";